/**
 * @file Detail view to show application settings.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertsService } from '../../core/alerts.service';
import { DialogService } from '../../core/dialog.service';
import { DetailBase } from '../../base/detail/detail.base';
import { FormBase } from '../../base/form/form.base';
import { BackendSettingsService } from '../../backend-settings.service';
import { UserService } from '../../user.service';
import { SettingsService } from '../../settings.service';
/**
 * Detail view to show application settings.
 * @export
 * @class SettingsDetailComponent
 * @extends {DetailComponent}
 */
var SettingsDetailComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsDetailComponent, _super);
    /**
     * Creates an instance of SettingsDetailComponent.
     * @param {configurationsService} configurationsService
     * @param {Router} router
     * @param {ActivatedRoute} route
     * @param {BackendSettingsService} breezeService
     * @param {DialogService} dialogService
     * @param {AlertsService} alertsService
     * @param {TranslateService} translateService
     *
     * @memberOf SettingsDetailComponent
     */
    function SettingsDetailComponent(userService, router, route, breezeService, dialogService, alertsService, settingsService, translateService) {
        var _this = _super.call(this, userService, router, route, breezeService, dialogService, alertsService, settingsService, translateService) || this;
        _this.breezeService = breezeService;
        _this.dialogService = dialogService;
        _this.alertsService = alertsService;
        return _this;
    }
    /**
     * After component is initialize and the configuration is known.
     * @protected
     * @memberOf SettingsDetailComponent
     */
    SettingsDetailComponent.prototype.afterInitialize = function () {
        var _this = this;
        // Get the components
        var components = Object.create(this.configuration.components);
        // Check the type of the component to handle specific situations
        components.forEach(function (component) {
            switch (component.component) {
                case 'SettingsFormComponent': {
                    _this.details = component;
                    break;
                }
                default: {
                    throw new Error('Unknown component (' + component.component + ')');
                }
            }
        });
    };
    return SettingsDetailComponent;
}(DetailBase));
export { SettingsDetailComponent };
